import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { JsonLDV2 } from '@discover/head/json-ld/v2';
import { $UserAgent } from '@lemon8/web-app-shared/atom';

export const JsonLD: FC = () => {
  const { isBot } = useAtomValue($UserAgent);

  if (!isBot) {
    return null;
  }

  return <JsonLDV2 />;
};
